<template>
  <div>
    <public-announcement />
    <div class="flex items-center justify-center min-h-screen p-4 overflow-hidden">
      <div class="relative z-10 w-108">
        <div class="flex items-center justify-center h-28">
          <span class="">
            <a href="https://ahaslides.com">
              <aha-logo
                width="165"
                height="28"
                viewBox="0 0 9600 1602"
              />
            </a>
          </span>
        </div>

        <div class="p-8 shadow-panel lg:p-8 rounded-3xl bg-base-0">
          <h2 class="text-center">
            Single Sign On
          </h2>

          <SSOForm />

          <p class="mb-4 text-sm text-center">
            Want to use Single Sign On for your team?<br>
            <a
              class="font-bold primary"
              href="https://form.typeform.com/to/j2O9GXjI/?campaign=login-sso"
              target="_blank"
            >Speak to our Enterprise team</a>
          </p>

          <div class="border-b border-base-30"></div>

          <p class="mt-4 text-sm text-center">
            <router-link to="/pages/login" class="font-bold primary">
              Log in without SSO
            </router-link>
          </p>
        </div>

        <span class="absolute hidden lg:block -left-24 bottom-18">
          <img src="@/assets/images/elements/trophy.svg">
        </span>

        <div class="h-28" />
      </div>

      <back-drop :wandElement="false" />
    </div>
  </div>
</template>

<script>
import BackDrop from '@/components-v2/common/auth/BackDrop.vue'
import SSOForm from '@/components-v2/sso/SSOForm.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'

// containers
import SSOFormContainer from '@/containers/sso/SSOForm'

export default {
  components: {
    BackDrop,
    SSOForm: SSOFormContainer(SSOForm),
    PublicAnnouncement,
  },
}
</script>
